// dependencies
import React, { useRef } from "react";
import { useIntl } from "react-intl";
import { StyleSheet } from "aphrodite";
import PropTypes from "prop-types";

// components
import Text from "@cloudspire/legacy-resources/src/components/Text2";
import Stack from "@cloudspire/legacy-resources/src/components/Stack";
import ActivityIndicator from "@cloudspire/legacy-resources/src/components/ActivityIndicator";

// containers
import { RoomAside as RoomAsideContainer } from "@cloudspire/legacy-resources/src/containers/Room";
import BookingAsideDetails from "./Details";
import BookingAsideActions from "./Actions";
import BookingAsideForm from "./Form";

// helpers
import { roomIsStateEnabled } from "@cloudspire/legacy-resources/src/helpers/room";

const styles = StyleSheet.create({
  error: {
    fontWeight: 700,
  },
});

function PlainAside(props) {
  const {
    priceToRender,
    hasBookingEstimateList,
    hasBookingEstimateResume,
    hasBookingEstimatePrice,
    hasBookingEstimateAdvance,
    hasPricingEstimatePrice,
    type,
    list,
    resume,
    bookingEstimatePrice,
    pricingEstimatePrice,
    advance,
    total,
    room,
    errorMessage,
    pricingEstimateResponse,
    bookingEstimateResponse,
    parameterList,
    bookingReference,
    shouldRenderLegend,
    shouldRenderBookingDetailButton,
    onChange,
    onPressContactUs,
    onPressOwnerContactMail,
    onPressOwnerContactPhone,
    onPressContactPhone,
    onPressContactMail,
  } = props;

  const intl = useIntl();

  const bookingEstimateLoading =
    !bookingEstimateResponse?.error && bookingEstimateResponse?.isValidating;

  const $inputCheckinRef = useRef();

  /**
   * Gère le clic sur le bouton de réservation
   */
  function handlePressBooking(event) {
    event.stopPropagation();
    if (!parameterList?.checkin || !parameterList?.checkout) {
      event.preventDefault();
      $inputCheckinRef.current?.focus?.();
    }
  }

  return (
    <>
      {!roomIsStateEnabled({ room }) ? (
        <Text>
          {intl.formatMessage({
            defaultMessage:
              "Hébergement non réservable pour une durée indéterminée",
          })}
        </Text>
      ) : (
        <>
          {("booking" === type || "payment" === type) && (
            <RoomAsideContainer room={room} />
          )}

          <BookingAsideForm
            type={type}
            room={room}
            parameterList={parameterList}
            shouldRenderLegend={shouldRenderLegend}
            inputCheckinRef={$inputCheckinRef}
            onChange={onChange}
          />

          {bookingEstimateLoading && (
            <>
              <Stack marginTop={0.875} />

              <ActivityIndicator />
            </>
          )}

          {(pricingEstimateResponse?.error || bookingEstimateResponse?.error) &&
            errorMessage && (
              <>
                <Stack marginTop={1} />

                <Text aStyle={styles.error}>{errorMessage}</Text>
              </>
            )}

          <BookingAsideDetails
            mode="plain"
            priceToRender={priceToRender}
            hasBookingEstimateList={hasBookingEstimateList}
            hasBookingEstimateResume={hasBookingEstimateResume}
            hasBookingEstimatePrice={hasBookingEstimatePrice}
            hasBookingEstimateAdvance={hasBookingEstimateAdvance}
            hasPricingEstimatePrice={hasPricingEstimatePrice}
            type={type}
            list={list}
            total={total}
            resume={resume}
            bookingEstimatePrice={bookingEstimatePrice}
            pricingEstimatePrice={pricingEstimatePrice}
            advance={advance}
            pricingEstimateResponse={pricingEstimateResponse}
            bookingEstimateResponse={bookingEstimateResponse}
            shouldRenderBookingDetailButton={shouldRenderBookingDetailButton}
            bookingReference={bookingReference}
          />

          <BookingAsideActions
            mode="plain"
            hasPricingEstimatePrice={hasPricingEstimatePrice}
            hasBookingEstimatePrice={hasBookingEstimatePrice}
            parameterList={parameterList}
            priceToRender={priceToRender}
            room={room}
            type={type}
            pricingEstimateResponse={pricingEstimateResponse}
            bookingEstimateResponse={bookingEstimateResponse}
            onPressContactUs={onPressContactUs}
            onPressOwnerContactMail={onPressOwnerContactMail}
            onPressOwnerContactPhone={onPressOwnerContactPhone}
            onPressContactPhone={onPressContactPhone}
            onPressContactMail={onPressContactMail}
            onPressBooking={handlePressBooking}
          />
        </>
      )}
    </>
  );
}

PlainAside.propTypes = {
  errorMessage: PropTypes.string,
  type: PropTypes.oneOf(["booking", "room", "payment"]),
  priceToRender: PropTypes.oneOf(["booking", "pricing"]),
  hasBookingEstimateList: PropTypes.bool,
  hasBookingEstimateResume: PropTypes.bool,
  hasBookingEstimatePrice: PropTypes.bool,
  hasBookingEstimateAdvance: PropTypes.bool,
  hasPricingEstimatePrice: PropTypes.bool,
  list: PropTypes.any,
  total: PropTypes.any,
  resume: PropTypes.any,
  bookingEstimatePrice: PropTypes.any,
  pricingEstimatePrice: PropTypes.any,
  advance: PropTypes.any,
  room: PropTypes.object,
  parameterList: PropTypes.any,
  shouldRenderLegend: PropTypes.bool,
  onChange: PropTypes.func,
  onPressContactUs: PropTypes.func,
  onPressOwnerContactMail: PropTypes.func,
  onPressOwnerContactPhone: PropTypes.func,
  onPressContactPhone: PropTypes.func,
  onPressContactMail: PropTypes.func,
};

export default PlainAside;
